import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { CountdownBanner } from './components/CountdownBanner';
import { PainSection } from './components/PainSection';
import { PromiseSection } from './components/PromiseSection';
import { TransformationSection } from './components/TransformationSection';
import { GuideSection } from './components/GuideSection';
import { ValueSection } from './components/ValueSection';
import { BonusSection } from './components/BonusSection';
import { SocialProof } from './components/SocialProof';
import { MetricsSection } from './components/MetricsSection';
import { FaqSection } from './components/FaqSection';
import { FinalPush } from './components/FinalPush';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1443459693942372');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1443459693942372&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-charcoal text-cream font-sans selection:bg-gold selection:text-charcoal" data-id="element-0">
      <HeroSection data-id="element-1" />
      <CountdownBanner data-id="element-2" />
      <PainSection data-id="element-3" />
      <PromiseSection data-id="element-4" />
      <TransformationSection data-id="element-5" />
      <GuideSection data-id="element-6" />
      <ValueSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <SocialProof data-id="element-9" />
      <MetricsSection data-id="element-10" />
      <FinalPush data-id="element-11" />
      <CountdownBanner data-id="element-12" />
      <CtaSection data-id="element-13" />
      <FaqSection data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}